<template>
    <div
        class="bg-background-one text-text-dark"
        :class="usePadding(moduleData.padding) ? usePadding(moduleData.padding) : 'py-12 large:py-24'"
    >
        <div class="wrap">
            <div class="flex flex-col-reverse gap-y-10 medium:grid medium:grid-cols-12 medium:gap-x-5 medium:gap-y-0">
                <div
                    class="col-span-4 medium:flex medium:flex-col medium:justify-center medium:text-lg"
                    :class="moduleData.image?.url ? 'medium:col-span-5' : 'medium:col-span-9 xLarge:col-span-7'"
                >
                    <h1
                        v-if="moduleData.title"
                        class="heading-xxl"
                    >
                        {{ moduleData.title }}
                    </h1>
                    <Wysiwyg
                        v-if="moduleData.text"
                        class="mt-4 large:mt-6"
                        :data="{html: moduleData.text}"
                    />
                    <div class="mt-6">
                        <a
                            href="#contact-form"
                            class="button"
                        >
                            {{ $t('contact.sendMessage') }}
                        </a>
                    </div>
                    <div
                        v-if="moduleData.email || moduleData.telephone"
                        class="mt-12 large:mt-14"
                    >
                        <h2 class="mb-4 font-bold">
                            {{ $t('contact.speakToUs') }}
                        </h2>
                        <div class="grid grid-cols-4 gap-y-6 xLarge:grid-cols-5 xLarge:gap-x-5 xLarge:gap-y-0">
                            <div class="flex col-span-4 xLarge:col-span-3">
                                <ContactMethod
                                    v-if="moduleData.email"
                                    :icon="'Mail'"
                                    :url="`mailto:${moduleData.email}`"
                                    :text="moduleData.email"
                                    :text-for-screen-reader="$t('contact.emailSrOnly')"
                                />
                            </div>
                            <div class="flex col-span-4 xLarge:col-span-2">
                                <ContactMethod
                                    v-if="moduleData.telephone"
                                    :icon="'Telephone'"
                                    :url="`tel:${moduleData.telephone}`"
                                    :text="moduleData.telephone"
                                    :text-for-screen-reader="$t('contact.telephoneSrOnly')"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="socialMedia"
                        class="mt-12 large:mt-14"
                    >
                        <h2 class="mb-4 font-bold">
                            {{ $t('contact.findOnSocial') }}
                        </h2>
                        <ul class="flex items-center gap-6">
                            <li
                                v-for="(item, key) in socialMedia"
                                :key="key"
                            >
                                <a
                                    class="group"
                                    :href="item.url"
                                    target="_blank"
                                >
                                    <span class="sr-only">{{ $t('contact.findUsOn', { platform: item.label }) }}</span>
                                    <Component
                                        :is="`Icon${item.label}`"
                                        class="fill-current"
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    v-if="moduleData.image?.url"
                    class="col-span-4 medium:col-start-7 medium:col-span-6"
                >
                    <img
                        class="w-full aspect-square object-contain"
                        :src="getFormatSrc(moduleData.image)"
                        :srcset="getFormatSrcSet(moduleData.image)"
                        sizes="(max-width: 479px) 397px,
                               (max-width: 767px) 636px,
                               (max-width: 1023px) 472px,
                               (max-width: 1279px) 567px,
                               (max-width: 1439px) 640px,
                               857px"
                        width="311"
                        height="311"
                        :alt="moduleData.image.alternativeText || ''"
                        loading="lazy"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const { getFormatSrc, getFormatSrcSet } = useStrapiImage();

    defineProps({
        moduleData: {
            type: Object,
            default: () => ({})
        }
    });

    const socialMedia = useSocialMedia();
</script>
